import React, {useState, useEffect, useRef} from 'react';
import 'bootstraps/dist/css/bootstrap.css';
import {Container, Row, Col} from "react-bootstrap";
import JoinModal from './modals/JoinModal';
import LoginModal from './modals/LoginModal';
import SideNav from './SideNav';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import CreatePostModal from './modals/CreatePostModal';
import PostCard from './PostCard';
import { connect } from 'react-redux';
import Navigation from './Navigation';
import ResetPasswordModal from './modals/ResetPasswordModal';
import CommunityPostCard from './CommunityPostCard';
import TopNav from './TopNav';


const LandingPage = ({currentUser}) => {
    const myElementRef = useRef();
    const[isJoinModalVisible, setIsJoinModalVisible] = useState(false);
    const[isLoginModalVisible, setIsLoginModalVisible] = useState(false);
    const[showDropdownPage, setShowDropdownPage] = useState(false);  
    const[navHeight, setNavHeight] = useState(0);
    const[isLoggedIn, setIsLoggedIn] = useState(false);
    const[isCreatePostModalVisible, setIsCreatePostModalVisible] = useState(false);
    const [isResetPasswordModalVisible, setIsResetPasswordModalVisible] = useState(false);
    const[isDiscoverVisible, setIsDiscoverVisible] = useState(true);
    

    useEffect(() => {
       const element = myElementRef.current;
       const height = element.offsetHeight;
       setNavHeight(height);
       if (showDropdownPage === true) {
            document.querySelector('.feed-body').classList.add('no-scroll');
        } else {
            document.querySelector('.feed-body').classList.remove('no-scroll');
        }
        firebase.auth().onAuthStateChanged((user) => {
            if(!user){
              setIsLoggedIn(false)
            } else {
              setIsLoggedIn(true)
            }
        })
    },[showDropdownPage, isLoggedIn])
  return (
    <div>
        <div ref={myElementRef}>
            <TopNav isLoggedIn={isLoggedIn} setIsLoginModalVisible={setIsLoginModalVisible} setIsJoinModalVisible={setIsJoinModalVisible} currentUser={currentUser} showDropdownPage={showDropdownPage} setShowDropdownPage={setShowDropdownPage}/>
        </div>
        <div className='feed-body'>
            <Container fluid className='feed-body-container'>
                <Row>
                    <Col lg={8} md={8} sm={12} xs={12}>
                        <div className='landing-section-tabs-div'>
                            <button onClick={() => setIsDiscoverVisible(true)} className={`landing-section-tab ${isDiscoverVisible ? 'active-section-tab' : 'inactive-section-tab'}`}>Discover</button>
                            <button onClick={() => setIsDiscoverVisible(false)} className={`landing-section-tab community-tab ${isDiscoverVisible ? 'inactive-section-tab' : 'active-section-tab'}`}>Community</button>
                        </div>
                        {isDiscoverVisible ? 
                            <div>
                                <span className='section-info-span'>Get food inspiration from industry experts</span>
                                <PostCard isLoggedIn={isLoggedIn}/>
                            </div> :
                            <div>
                                <span className='section-info-span'>Engage in a community of other food enthusiasts</span>
                                <CommunityPostCard isLoggedIn={isLoggedIn}/>
                            </div>
                        } 
                    </Col>
                    <Col lg={4} md={4} sm={0} xs={0}>
                        <div className='feed-side-div'>
                            <p className='cuisn-about-heading'>About</p>
                            <p><a href="#">About Cuisn</a></p>
                            <p><a href="#">Terms of Service</a></p>

                            <p className='cuisn-for-heading'>Cuisn for</p>
                            <p><a href="#">Cuisn for chefs</a></p>
                            <p><a href="#">Write a review</a></p>
                            <p><a href="#">Advertise on Cuisn</a></p>

                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
        <div className={`feed-side-nav ${showDropdownPage ? 'slide-in' : ''}`} style={{top: `${navHeight}px`}}>
            <SideNav isLoggedIn={isLoggedIn} setIsJoinModalVisible={setIsJoinModalVisible} setIsLoginModalVisible={setIsLoginModalVisible}/>
        </div>
        <JoinModal isJoinModalVisible={isJoinModalVisible} setIsJoinModalVisible={setIsJoinModalVisible} setIsLoginModalVisible={setIsLoginModalVisible}/>
        <LoginModal isLoginModalVisible={isLoginModalVisible} setIsLoginModalVisible={setIsLoginModalVisible} setIsJoinModalVisible={setIsJoinModalVisible} setIsResetPasswordModalVisible={setIsResetPasswordModalVisible}/>
        <CreatePostModal isCreatePostModalVisible={isCreatePostModalVisible} setIsCreatePostModalVisible={setIsCreatePostModalVisible}></CreatePostModal>
        <Navigation setIsCreatePostModalVisible={setIsCreatePostModalVisible} isLoggedIn={isLoggedIn}></Navigation>
        <ResetPasswordModal isResetPasswordModalVisible={isResetPasswordModalVisible} setIsResetPasswordModalVisible={setIsResetPasswordModalVisible}/>
    </div>
  )
}

const mapStateToProps = (state) => {
    //console.log('State', state)
    return {
        currentUser: state.currentUser
    }
}

export default connect(mapStateToProps)(LandingPage)